import React, { useEffect, useState } from 'react';
import Layout from '../../../components/common/pageLayout';
import { toast } from 'react-toastify';
import ListRole from '../../../components/Administration/module/assign';
import { v3_roles } from '../../../actions/v3/role';
import constant from '../../../constant';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { v3_module_assign } from '../../../actions/v3/module';

const List = (props) => {
    const location = useLocation();
    const { page } = location.state || {};

    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);


    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const res = await v3_roles(currentPage, limit);
                if (res.status) {
                    setData(res.result);

                } else {
                    toast.error(res.error);
                }
            } catch (error) {
                toast.error('Failed to fetch roles.');
            }
        };

        fetchRoles();
    }, [currentPage, limit, props.history]);


    return (
        <Layout title={'Assign Module'}>
            {data && (
                <ListRole
                    data={data}
                    limit={limit}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </Layout>
    );
};

export default List;
